//I hate this, but someone may have bookmarked the old pages, and that will start an endless loading loop after deprecating the pages
const disallowedRoutes = ['/closer', '/fronter']

export function getLoginMissLocation() {
  const location = localStorage.getItem('TD-loginMissRedirect')
  if (
    location === '/' ||
    location === '' ||
    disallowedRoutes.includes(location as string) ||
    location?.indexOf('/onelogin') != -1
  ) {
    return '/turboscript'
  }
  return location
}
